import { render } from "./CategoryPages.vue?vue&type=template&id=3e4713ee"
import script from "./CategoryPages.vue?vue&type=script&lang=js"
export * from "./CategoryPages.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__